/**
 * Таблиці QR-коду (ISO/IEC 18004) для рівня корекції M — 15 % відновлення, звичний для QR застосунків-автентифікаторів. Індекс — версія
 * 1…20 (нульовий не використовується): кодових слів корекції на блок і кількість блоків. Версії 20 (666 байтів) досить для otpauth-адрес.
 */
export const qrMaxVersion = 20;

/** Кодових слів корекції помилок на блок (рівень M). */
const ECC_PER_BLOCK = [-1, 10, 16, 26, 18, 24, 16, 18, 22, 22, 26, 30, 22, 22, 24, 24, 28, 28, 26, 26, 26];

/** Кількість блоків корекції помилок (рівень M). */
const BLOCKS = [-1, 1, 1, 1, 2, 2, 4, 4, 4, 5, 5, 5, 8, 9, 9, 10, 10, 11, 13, 14, 16];

/** Біти рівня корекції M у форматному слові (L = 01, M = 00, Q = 11, H = 10). */
export const qrEclBits = 0;

/** Сторона матриці версії: 17 + 4 × версія модулів. */
export const qrSize = (version: number): number => version * 4 + 17;

/**
 * Модулів даних і корекції в матриці версії — уся площа без шаблонів пошуку, синхронізації, вирівнювання, формату й версії. Чиста функція.
 */
export function qrRawModules(version: number): number {
  let result = (16 * version + 128) * version + 64;
  if (version >= 2) {
    const align = Math.floor(version / 7) + 2;
    result -= (25 * align - 10) * align - 55;
    if (version >= 7) result -= 36;
  }
  return result;
}

/** Кодових слів корекції на блок версії. Чиста функція. */
export const qrEccPerBlock = (version: number): number => ECC_PER_BLOCK[version] ?? 0;

/** Блоків корекції версії. Чиста функція. */
export const qrBlocks = (version: number): number => BLOCKS[version] ?? 1;

/** Кодових слів даних версії (без корекції). Чиста функція. */
export const qrDataCodewords = (version: number): number => Math.floor(qrRawModules(version) / 8) - qrEccPerBlock(version) * qrBlocks(version);

/** Центри шаблонів вирівнювання версії (рядки й стовпці однакові). Чиста функція. */
export function qrAlignmentPositions(version: number): number[] {
  if (version === 1) return [];
  const count = Math.floor(version / 7) + 2;
  const step = Math.ceil((version * 4 + 4) / (count * 2 - 2)) * 2;
  const result = [6];
  for (let pos = qrSize(version) - 7; result.length < count; pos -= step) result.splice(1, 0, pos);
  return result;
}
